// Call QA (L1) types + UI helpers.
//
// Types now come from the generated schema (backend is live). We re-alias the
// generated `CallQaOutput` / `QaQuestionOutput` to the names the QA components use,
// and keep the small presentational helpers (colors, category order) here.

import { CallQaFieldsFragment } from '../../../../../../shared';
import { QaQuestionOutput } from '@coverright/data-access/types/enrollment';

export type CallQa = CallQaFieldsFragment;
export type CallQaQuestion = QaQuestionOutput;

// answer is a free String on the schema; these are the rubric's valid values.
export type QaAnswer = 'Yes' | 'No' | 'Not Stated' | 'N/A';

export type QaCategory =
  | 'Mandatory Compliance'
  | 'Fact Finding & Needs Analysis'
  | 'Enrollment & Soft Skills';

// The three rubric categories, in display order (exact strings — do not change).
export const QA_CATEGORIES: QaCategory[] = [
  'Mandatory Compliance',
  'Fact Finding & Needs Analysis',
  'Enrollment & Soft Skills',
];

// Score color bands (locked from the design deck).
export const scoreColor = (score: number): string =>
  score >= 90 ? '#0DBC83' : score >= 75 ? '#EB9C15' : '#F14E42';

// Answer chip colors.
export const answerColors = (answer: string): { bg: string; fg: string; border: string } => {
  switch (answer) {
    case 'Yes':
      return { bg: '#E6F7F1', fg: '#056048', border: '#0DBC83' };
    case 'No':
    case 'Not Stated':
      return { bg: '#FDECEA', fg: '#B42318', border: '#F14E42' };
    case 'N/A':
    default:
      return { bg: '#F3F4F6', fg: '#6B7280', border: '#D1D5DB' };
  }
};